import Swiper from 'swiper';
// import 'waypoints/lib/noframework.waypoints.min.js';
// import 'remodal';

// header高さ
if (window.matchMedia('(max-width: 559px)').matches) {
	// spのみ
	var space = '70';
} else {
	// pcのみ
	var space = '90';
}

// スクロール
var Ease = {
	easeInOut: (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
};
var duration = 500;
window.addEventListener('DOMContentLoaded', () => {
	var smoothScrollTriggers = document.querySelectorAll('.anchor');
	smoothScrollTriggers.forEach(function (smoothScrollTrigger) {
		smoothScrollTrigger.addEventListener('click', function (e) {
			var href = smoothScrollTrigger.getAttribute('href');
			var currentPostion = document.documentElement.scrollTop || document.body.scrollTop;
			var targetElement = document.getElementById(href.replace('#', ''));
			if (targetElement) {
				e.preventDefault();
				e.stopPropagation();
				var targetPosition = window.pageYOffset + targetElement.getBoundingClientRect().top - space;
				var startTime = performance.now();
				var loop = function (nowTime) {
					var time = nowTime - startTime;
					var normalizedTime = time / duration;
					if (normalizedTime < 1) {
						window.scrollTo(0, currentPostion + (targetPosition - currentPostion) * Ease.easeInOut(normalizedTime));
						requestAnimationFrame(loop);
					} else {
						window.scrollTo(0, targetPosition);
					}
				};
				requestAnimationFrame(loop);
			}
		});
	});
});

//// スライダー
// KEY VISUAL
let fade = document.querySelectorAll('.fade');
for (let i = 0; i < fade.length; i++) {
	const swiper = document.querySelectorAll('.keyvisual .swiper-container')[i];
	new Swiper(swiper, {
		loop: true,
		watchOverflow: true,
		slidesPerView: 1,
		centeredSlides: true,
		spaceBetween: 30,
		speed: 1000,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		pagination: {
			el: document.querySelectorAll('.keyvisual .swiper-pagination')[i],
			type: 'bullets',
			clickable: true,
		},
		breakpoints: {
			559: {
				slidesPerView: 2.5,
			},
		},
	});
}

// SHOP TAB
const shopArea = document.querySelector('.shopArea');
const shopThumb = document.querySelector('.shopThumb');
const tabNavi = new Swiper(shopThumb, {
	// spaceBetween: 10,
	slidesPerView: 2,
	// allowTouchMove: false,
	// loop: true,
	// freeMode: true,
	// loopedSlides: 5, //looped slides should be the same
	// watchSlidesVisibility: true,
	// watchSlidesProgress: true,
});
const shopDisplay = new Swiper(shopArea, {
	effect: 'fade',
	fadeEffect: {
		crossFade: true,
	},
	hashNavigation: {
		replaceState: true,
		watchState: true,
	},
	loop: true,
	speed: 400,
	autoHeight: true,
	allowTouchMove: false,
	thumbs: {
		swiper: tabNavi,
	},
});

// グロナビ操作
let myTarget1 = document.querySelectorAll('.navi-coffee');
for (let i = 0; i < myTarget1.length; i++) {
	myTarget1[i].addEventListener('click', () => {
		shopDisplay.slideTo(1);
	});
}
let myTarget2 = document.querySelectorAll('.navi-kitchen');
for (let i = 0; i < myTarget2.length; i++) {
	myTarget2[i].addEventListener('click', () => {
		shopDisplay.slideTo(2);
	});
}

// タブ切り替わりで上部までスクロール
shopDisplay.on('slideChange', () => {
	const element = document.querySelector('.shopArea');
	const rect = element.getBoundingClientRect();
	const elemtop = rect.top + window.pageYOffset - space;
	window.scrollTo({
		top: elemtop,
		behavior: 'smooth',
	});
	// console.log('変わった');
	funcAnim();
});

// 下層ページからのアンカー位置ずれ解消
if (location.hash) {
	// const headerHeight = document.getElementById('js-header').clientHeight;
	setTimeout(() => {
		if (window.matchMedia('(max-width: 559px)').matches) {
			// spのみ
			window.scrollBy(0, -space);
		} else {
			// pcのみ
			window.scrollBy(0, -space);
		}
	}, 100);
}

// MENU箇所 SPのみスライダー
let slide = document.querySelectorAll('.kitchen-menu .slide');
for (let i = 0; i < slide.length; i++) {
	let mySwiper = null;
	let itemSlider = null;

	const mediaQuery = window.matchMedia('(max-width: 559px)');

	const checkBreakpoint = (e) => {
		if (e.matches) {
			initSwiper();
		} else if (mySwiper) {
			mySwiper.destroy(false, true);
			itemSlider.destroy(false, true);
		}
	};

	const initSwiper = () => {
		const swiperVisual = document.querySelectorAll('.kitchen-menu .visual')[i];
		const swiperItem = document.querySelectorAll('.kitchen-menu .item')[i];
		itemSlider = new Swiper(swiperItem, {
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			speed: 400,
			autoHeight: true,
		});
		mySwiper = new Swiper(swiperVisual, {
			loop: true,
			spaceBetween: 20,
			speed: 400,
			navigation: {
				nextEl: document.querySelectorAll('.kitchen-menu .swiper-button-next')[i],
				prevEl: document.querySelectorAll('.kitchen-menu .swiper-button-prev')[i],
			},
			thumbs: {
				swiper: itemSlider,
			},
		});
	};

	// mediaQuery.addListener(checkBreakpoint);
	mediaQuery.addEventListener('change', checkBreakpoint);
	checkBreakpoint(mediaQuery);
}

//アニメーション
window.addEventListener('load', function () {
	window.addEventListener('scroll', () => {
		funcAnim();
	});
});

function funcAnim() {
	let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	let myMain = document.querySelectorAll('.anim');
	for (let i = 0; i < myMain.length; i++) {
		let rect = myMain[i].getBoundingClientRect();
		let posiTop = rect.top + scrollTop; // ターゲットがブラウザTOPに来たら
		// let posiMid = posiTop - window.innerHeight / 2; // ターゲットがブラウザMIDに来たら
		let posiBtm = posiTop - window.innerHeight; // ターゲットがブラウザBOTOMに来たら
		let myHeight = myMain[i].clientHeight - 100;
		let position_bottom = posiTop + myHeight; // ターゲットが下からスクロールしたときに見える位置

		// ターゲットが来た時ときの動き
		if (scrollTop > posiBtm && scrollTop < position_bottom) {
			myMain[i].classList.add('active');
			// console.log('きた');
		} else {
			// それ以外の動き
			myMain[i].classList.remove('active');
		}
	}
}
